import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// ─── Immediate viewport height fix ───────────────────────────────────────────
// Set --vh on <html> synchronously before React hydrates so CinematicHero
// never flashes the wrong height on any device (mobile, tablet, desktop, 4K).
// On mobile, window.innerHeight includes browser chrome (address bar) and
// gives a value larger than the actual visible area — visualViewport.height
// is the correct source of truth. On desktop both are identical.
(function setVhImmediate() {
  const vh = (window.visualViewport?.height ?? window.innerHeight) * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
